exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-a79b2038]{\n    width: 300px;\n}\n", ""]);

// exports
